var _defs, _title, _title2, _title3, _title4, _title5, _title6, _title7, _title8, _title9, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _title10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRneFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 39.31 27.55",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e0c589;}.cls-2{fill:#f4deb3;}.cls-3{fill:#fff;}.cls-4{fill:none;stroke:#7a5a21;stroke-miterlimit:10;stroke-width:2px;}.cls-5{fill:#7a5a21;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rne_back") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.545,
    y: 4.576,
    width: 10.352,
    height: 11.955,
    rx: 1.86,
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.363877, 0, 0, 0.363877, -5.38501, -11.661064)",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Foto 3x4")), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(250, 169, 128)",
      vectorEffect: "non-scaling-stroke"
    },
    d: "M 35.642 63.68 L 34.575 66.308 C 34.489 72.403 42.174 73.298 42.272 66.286 L 41.361 63.847 L 35.642 63.68 Z"
  }, _title2 || (_title2 = /*#__PURE__*/React.createElement("title", null, "Pesco\xE7o"))), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(254, 187, 135)",
      vectorEffect: "non-scaling-stroke"
    },
    cx: 38.604,
    cy: 57.295,
    rx: 5.831,
    ry: 7.412
  }, _title3 || (_title3 = /*#__PURE__*/React.createElement("title", null, "Rosto"))), /*#__PURE__*/React.createElement("path", {
    d: "M 36.318 47.214 C 34.076 47.593 32.797 48.984 32.24 51.626 C 31.815 53.642 31.815 54.607 32.24 54.607 C 32.509 54.607 32.532 54.807 32.442 55.592 C 32.284 56.667 32.486 58.192 32.778 58.192 C 32.868 58.192 33.023 57.408 33.091 56.443 C 33.157 55.28 33.359 54.36 33.675 53.755 C 34.212 52.68 34.212 52.704 34.883 53.15 C 35.511 53.552 36.272 53.6 39.296 53.373 C 42.345 53.15 42.86 53.373 43.531 55.166 C 43.777 55.838 44.069 56.801 44.135 57.295 C 44.361 58.706 44.674 58.347 44.674 56.645 C 44.674 55.704 44.81 54.853 45.01 54.474 C 45.659 53.24 44.942 50.372 43.733 49.342 C 43.196 48.87 43.106 48.714 43.33 48.445 C 43.553 48.176 43.398 48.063 42.389 47.795 C 41.202 47.437 38.357 46.988 37.73 47.01 C 37.55 47.034 36.899 47.124 36.318 47.214 Z",
    style: {
      vectorEffect: "non-scaling-stroke"
    }
  }, _title4 || (_title4 = /*#__PURE__*/React.createElement("title", null, "Cabelo"))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(248, 239, 248)",
      vectorEffect: "non-scaling-stroke"
    },
    points: "34.322 66.239 38.682 67.35 42.591 66.172 39.994 76.012 37.259 76.012"
  }, _title5 || (_title5 = /*#__PURE__*/React.createElement("title", null, "Camisa"))), /*#__PURE__*/React.createElement("path", {
    d: "M 34.28 66.212 C 34.076 66.548 32.576 67.197 28.992 68.543 C 27.332 69.146 25.764 69.798 25.496 69.954 C 24.825 70.38 24.353 71.498 24.061 73.315 C 23.928 74.165 23.77 75.152 23.726 75.488 L 23.636 76.07 L 38.625 76.07 C 46.892 76.07 53.636 76.003 53.636 75.935 C 53.636 75.108 52.919 71.724 52.607 71.073 C 52.112 69.998 51.866 69.864 48.146 68.497 C 46.422 67.848 44.518 67.085 43.935 66.773 C 43.33 66.48 42.814 66.258 42.77 66.302 C 42.724 66.347 42.097 68.43 41.336 70.94 C 40.595 73.448 39.924 75.553 39.877 75.623 C 39.746 75.733 39.589 74.681 39.41 72.641 C 39.32 71.768 39.184 70.672 39.075 70.178 C 38.915 69.482 38.961 69.213 39.208 68.923 C 39.5 68.61 39.5 68.476 39.252 68.072 C 39.094 67.802 38.805 67.601 38.625 67.601 C 38.447 67.601 38.154 67.802 37.999 68.072 C 37.752 68.476 37.752 68.61 38.02 68.902 C 38.287 69.191 38.311 69.505 38.178 70.29 C 38.064 70.85 37.909 72.239 37.819 73.382 C 37.73 74.523 37.594 75.488 37.504 75.553 C 37.414 75.6 36.877 74.053 36.294 72.127 C 34.614 66.48 34.436 65.965 34.28 66.212 Z",
    style: {
      vectorEffect: "non-scaling-stroke"
    }
  }, _title6 || (_title6 = /*#__PURE__*/React.createElement("title", null, "Terno"))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(218, 23, 42)",
      vectorEffect: "non-scaling-stroke"
    },
    points: "38.331 67.606 38.945 67.606 39.561 68.54 39.052 69.316 39.037 69.716 39.962 75.468 40.024 76.073 37.405 76.066 38.24 69.701 38.218 69.292 37.693 68.498"
  }, _title7 || (_title7 = /*#__PURE__*/React.createElement("title", null, "Gravata"))), /*#__PURE__*/React.createElement("g", null, _title8 || (_title8 = /*#__PURE__*/React.createElement("title", null, "Terno dobrado")), /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(121, 121, 121)",
      vectorEffect: "non-scaling-stroke"
    },
    points: "35.414 76.073 36.64 75.294 37.783 72.449 36.531 72.291 37.83 70.059 34.064 66.057 32.066 66.056",
    transform: "matrix(-1, 0, 0, -1, 69.896004, 142.128998)"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(121, 121, 121)",
      vectorEffect: "non-scaling-stroke"
    },
    points: "42.362 65.942 43.524 66.626 44.663 69.542 43.411 69.815 45.095 71.797 41.611 76.068 39.693 76.074"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(255, 255, 255)",
      vectorEffect: "non-scaling-stroke"
    },
    points: "38.993 67.493 38.295 67.492 36.623 69.518 34.369 66.193 35.235 64.372 38.262 67.25 39.021 67.25 41.658 64.349 42.5 66.263 40.518 69.428"
  }, _title9 || (_title9 = /*#__PURE__*/React.createElement("title", null, "Colarinho")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3.54 1 L 35.77 1 C 37.173 1 38.31 2.137 38.31 3.54 L 38.31 24.01 C 38.31 25.413 37.173 26.55 35.77 26.55 L 3.54 26.55 C 2.137 26.55 1 25.413 1 24.01 L 1 3.54 C 1 2.137 2.137 1 3.54 1 Z M 3.8 6.99 L 3.8 14.08 C 3.8 15.107 4.633 15.94 5.66 15.94 L 11.72 15.94 C 12.747 15.94 13.58 15.107 13.58 14.08 L 13.58 6.99 C 13.58 5.963 12.747 5.13 11.72 5.13 L 5.66 5.13 C 4.633 5.13 3.8 5.963 3.8 6.99 Z",
    className: "cls-1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.05,
    y: 13.91,
    width: 10.46,
    height: 2.03
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.59,
    y: 18.05,
    width: 36.14,
    height: 7.73
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 19.345,
    y: 1.56,
    width: 18.375,
    height: 4.07,
    style: {}
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1,
    y: 1,
    width: 37.31,
    height: 25.55,
    rx: 2.54
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 3.8,
    y: 19.34,
    width: 31.71,
    height: 2.57
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 14.42,
    y: 5.13,
    width: 9.78,
    height: 10.81,
    rx: 1.86
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 25.05,
    y: 10.53,
    width: 10.46,
    height: 2.03
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.08406, 0, 0, 0.018685, 20.033455, 2.194789)",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _title10 || (_title10 = /*#__PURE__*/React.createElement("title", null, "Bar code")), /*#__PURE__*/React.createElement("rect", {
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.864,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.729,
    width: 4.297,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.322,
    width: 4.297,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.051,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.915,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.779,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.508,
    width: 4.297,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.101,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.83,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.695,
    width: 4.297,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.423,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.288,
    width: 4.297,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.016,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.881,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.745,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.474,
    width: 4.297,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.067,
    width: 4.297,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.796,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.525,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.253,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.118,
    width: 4.297,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.847,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.711,
    width: 4.297,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.304,
    width: 4.297,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.033,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.762,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.626,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.355,
    width: 4.297,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.084,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.948,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.812,
    width: 4.297,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.405,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.134,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.999,
    width: 4.297,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.727,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.456,
    width: 4.297,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.185,
    width: 4.297,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.914,
    width: 1.432,
    height: 82.639,
    style: {},
    y: 24.596
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      font: "20px monospace"
    },
    textAnchor: "middle",
    x: 135,
    y: 122,
    transform: "matrix(0.370468, 0, 0, 1.36934, 48.667931, -31.943218)"
  }, "31831716692148")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRneFront);
export default __webpack_public_path__ + "static/media/rne_front.e61741268fa1b7e2dd752911c5b6fc0a.svg";
export { ForwardRef as ReactComponent };